'use client';

import type { CSSProperties, ReactElement } from 'react';
import { Cbutton } from '../Cbutton/Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
import { dataEl, type DataElScope } from '@/utils/dataEl';

interface MessageModalPrimaryButtonProps {
    dataElScope: DataElScope;
  label?: string;
  preset: ButtonPreset;
  loading: boolean;
  padding?: string;
  height?: number;
  style: CSSProperties;
  onClick: () => void;
}

export function MessageModalPrimaryButton({
  dataElScope,
  label,
  preset,
  loading,
  padding,
  height,
  style,
  onClick,
}: MessageModalPrimaryButtonProps): ReactElement | null {
  if (!label) {
    return null;
  }

  return (
    <Cbutton
      rootAttributes={{ "data-el": dataEl(dataElScope, 'PrimaryButton/Root') }}
      preset={preset}
      label={label}
      onClick={onClick}
      disabled={loading}
      isLoading={loading}
      padding={padding}
      height={height}
      style={style}
    />
  );
}
